import protectedComponent from 'components/helpers/protectedComponent';

import action from 'common/rbac/actions';

export default protectedComponent(() => import('./AddClient'), {
  action: action.ADD_CLIENT,
});
